import axios from 'axios';

const axiosInstance = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL });

// The backend is multi-tenant: every API call must carry the active store's
// `shop` domain so the tenant middleware can resolve `req.tenant` (otherwise it
// responds 400 "shop not specified"). The shop is captured from the iframe URL
// (?shop=) at app boot and persisted in sessionStorage (see index.js); this
// request interceptor appends it to every request. Using `config.params` (rather
// than string-concatenating the URL) lets axios merge it safely with any query
// string already present on the request.
axiosInstance.interceptors.request.use((config) => {
	// sessionStorage can throw a SecurityError in a partitioned/blocked
	// third-party iframe; never let that reject an API request.
	let shop = null;
	try {
		shop = sessionStorage.getItem('shop');
	} catch {
		shop = null;
	}

	// Storage fully denied (Safari "Block All Cookies", sandboxed iframe,
	// Lockdown Mode): the boot-time write never persisted, so fall back to the
	// iframe URL itself — the embed passes ?shop= on every load.
	if (!shop) {
		try {
			shop = new URLSearchParams(window.location.search).get('shop');
		} catch {
			shop = null;
		}
	}

	if (shop) {
		config.params = { ...config.params, shop };
	}

	return config;
});

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) =>
		Promise.reject(
			(error.response && error.response.data) || 'Something went wrong'
		)
);

export default axiosInstance;
